/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { homeRouteEntry } from './home/HomeRoute';
import { companytrackerRouteEntry } from './company-tracker';
import { sdgapRouteEntry } from './sdgap/SdgapRoute';
import { emissionsCalculatorsRouteEntry } from './emissions-calculators';
import { portfolioTrackerRouteEntry } from './portfolio-tracker';
import { worldTrackerRouteEntry } from './world-tracker/WorldTrackerRoute';
import { RouteInterface } from '../types/routes';
import { statsRouteEntry } from './stats';
import { productsRouteEntry } from './product-page-container';
import { assuranceRouteEntry } from './assurance';
import { materialityAssessmentRouteEntry } from '../apps/materiality-assessment/routes/MaterialityAssessmentRoute';
import { passwordResetRedirectRoute } from './password/PasswordResetRedirectRoute';

// Entry Routes for each app
export const appEntryRoutes: RouteInterface[] = [
  homeRouteEntry,
  companytrackerRouteEntry,
  portfolioTrackerRouteEntry,
  assuranceRouteEntry,
  worldTrackerRouteEntry,
  sdgapRouteEntry,
  emissionsCalculatorsRouteEntry,
  productsRouteEntry,
  statsRouteEntry,
  materialityAssessmentRouteEntry,
  passwordResetRedirectRoute,
];
